import { SecLoginFavouriteSettingService } from './security/sec-login-favourite/sec-login-favourite-setting.service';
import { HttpClientModule } from '@angular/common/http';
// angular modules

import { BrowserModule } from '@angular/platform-browser';
import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
// import { HttpModule, Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
/** --------------------------------------------------------------------------------- **/
// app component modules
import { AppComponent } from './app.component';
import { AppRoutesModule } from './app.routing';
import { dashboardComponent } from './dashboard';

import { dashboardComponentEmpty } from './dashboard';
/** --------------------------------------------------------------------------------- **/
// main module
/** --------------------------------------------------------------------------------- **/

// import { IdentityTypesComponent } from './blocks/identity_type/identity_types.component';
// import { NamesComponent } from './blocks/names/names.component';
import { BlocksModule } from './blocks/blocks.module';
import { CountsDashBoardModule } from './blocks/counts-dashboard/counts-dashboard.module';
/** --------------------------------------------------------------------------------- **/
// ui modules
import { NgbModule } from './ng-bootstrap/index';
import { ToastrModule } from 'ngx-toastr';
// services

import { HttpGeneralService } from './shared/http-general.service';
import { CountsDashBoardService } from './blocks/counts-dashboard/counts-dashboard.service';
import { SharedModule, MessageService, Navbar, AuthService, FormSettingsService } from './shared';
import { LoggedInGuard } from './shared';
import { UserSessionService } from './app-user-session.service';
/** --------------------------------------------------------------------------------- **/
// directives
import { DropdownDirective } from './dropdown.directive';
/** --------------------------------------------------------------------------------- **/
// general helper modules
// transelate module
import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
// import { CKEditorModule } from 'ngx-ckeditor';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
// ----------------------------------------------------------------------
import {
  EntityService,
  ModalService,
  ToastService,
  ControlsService,
  FilterService,
  ExceptionService,
  SpinnerService,
  SpinnerComponent,
  ToastComponent,
  ModalComponent,
  LinkTypePipe
} from './blocks';

import { Login } from './login';
// import { CustomErrorHandler } from './custom-error-handler';
import { ModulesComponent } from './modules/modules.component';
import { ModuleService } from './modules/module.service';
import { SingelDocumentViewerModule } from './document-management/document-viewer/singel-document-viewer/singel-document-viewer.component';
import { HomeModule } from './signalr-test/home/home.module';
import { NotifySignalrService } from './shared/notify-signalr.service';
import { AlertService } from './shared/notify-and-alert.service';
import { ChangePasswordComponent } from './security/changePassword/change-password.component';
import { UserService } from './security/userData';
import { SecLoginFavouriteSettingComponent } from './security/sec-login-favourite/sec-login-favourite-setting.component';
import { FavoriteService } from './security/favorite';
import { MailModule } from './blocks/mail/mail/mail.component';
import { MailsboxModule } from './mailsbox/mailsbox.module';
import { NewSignalrAlertService } from './shared/new-signalr-alert.service';
import { EmrSpecialtyMarkersService } from './medical-sheets/emr-specialty-markers/emr-specialty-markers.service';
import { EmrSpecialtyImagesService } from './medical-sheets/emr-specialty-images/emr-specialty-images.service';
import { imageUploadAllService } from './docu-manage-new/image-upload-all/image-upload-all.service';
import { PatientSheetService } from './medical-sheets/patient-sheet/patient-sheet.service';
import { CallPatientRepoService } from './outpatient/portal-scheduling-management/scheduling-manage-tabs/call-patient-repo.service';
import { DatePipe } from '@angular/common';
//import { NgxQRCodeModule } from '@techiediaries/ngx-qrcode';
import { StockHelper } from './stock-trans-exchange-outpatient/stock-trans-exchange-outpatient-help/stock-outpatient.helper';
import { GenerateQrCodeService } from './stock-trans-exchange-outpatient/stock-trans-exchange-outpatient-help/generate-qr-code.service';
import { CashierTransService } from './cashier/cashier-trans';
import { HrGeneralizationsAlertsService } from './personnel-setup/hr-generalizations-alerts-setup/hr-generalizations-alerts-setup.service';
import { OrderWorkFlowPopupComponent } from './order-work-flow-popup/order-work-flow-popup.component';
import { EmrRestraintOrderComponent } from './emr-restraint/emr-restraint-order/emr-restraint-order.component';
import { LaserDermaClinicComponent } from './laser-derma-clinic/laser-derma-clinic.component';
import { OutPatReservationService } from './outpatient/out-pat-appointment/out-pat-reservation/out-pat-reservation.service';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { NgxBarcode6Module } from 'ngx-barcode6';
//  import { QRCodeModule } from 'angularx-qrcode';

import { physicalTherapySessionModule } from './orders/physical-therapy-session/physical-therapy-session.module';
import { InfectionControlModule } from './infection-control/infection-control.module';
import { EditorModule, TINYMCE_SCRIPT_SRC } from '@tinymce/tinymce-angular';

//import { AgmCoreModule } from '@agm/core';


// import { ZoneListener } from './shared/zone.listener';


@NgModule({
  declarations: [
    AppComponent,
    SpinnerComponent,
    ToastComponent,
    ModalComponent,
    LinkTypePipe,
    dashboardComponent,
    dashboardComponentEmpty,
    // Directives
    DropdownDirective,
    Login,
    Navbar,
    ChangePasswordComponent,
    SecLoginFavouriteSettingComponent,
    OrderWorkFlowPopupComponent,
    LaserDermaClinicComponent
  ],
  imports: [
    // angular modules
    //HttpClientModule,
    BrowserAnimationsModule,
    NgbModule.forRoot(),
    ToastrModule.forRoot(),
    // general modules
    BlocksModule,
    BrowserModule,
    SharedModule,
    CountsDashBoardModule,
    HttpClientModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      }
    }),
    MailModule,
    MailsboxModule,
    // AgmCoreModule.forRoot({
    //     apiKey: 'AIzaSyAcrIrPWIItAnQPI6X3AAUKqxzboPb74p0'
    //   }),
    //////Main Modules ************************************************-
    // lazy laod module
    // IdentityTypesComponent,
    // NamesComponent,
    ModulesComponent,
    // used last module in all time for matched url
    AppRoutesModule,
    HomeModule,
    SingelDocumentViewerModule,
    // CKEditorModule,
    CKEditorModule,
    //NgxQRCodeModule,
    NgxBarcode6Module,
  //  QRCodeModule,

    InfectionControlModule,
    physicalTherapySessionModule, EditorModule
  ],
  exports: [BrowserModule, DropdownDirective],
  providers: [
    HttpClient,
    EntityService,
    ModalService,
    FilterService,
    ToastService,
    ExceptionService,
    MessageService,
    ControlsService,
    SpinnerService,
    AuthService,
    FormSettingsService,
    LoggedInGuard,
    UserSessionService,
    HttpGeneralService,
    ModuleService,
    CountsDashBoardService,
    NotifySignalrService,
    NewSignalrAlertService,
    AlertService,
    UserService,
    SecLoginFavouriteSettingService,
    FavoriteService,
    EmrSpecialtyMarkersService,
    EmrSpecialtyImagesService,
    PatientSheetService,
    imageUploadAllService,
    CallPatientRepoService,
    DatePipe,
    StockHelper,
    GenerateQrCodeService,
    CashierTransService,
    HrGeneralizationsAlertsService,
    OutPatReservationService,
    // { provide: ErrorHandler, useClass: CustomErrorHandler },
    // ZoneListener,
    // { provide: RouteReuseStrategy, useClass: PreventErrorRouteReuseStrategy },
    // { provide: APP_BASE_HREF, useValue: location.pathname }
    { provide: TINYMCE_SCRIPT_SRC, useValue: 'tinymce/tinymce.min.js' }

  ],
  bootstrap: [AppComponent],
  schemas: [NO_ERRORS_SCHEMA] // add this line
})
export class AppModule {

  constructor() {
  }
}


